import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebase';

const Footer = () => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const docRef = doc(db, "settings", "home");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setConfig(docSnap.data());
        }
      } catch (error) {
        console.error("Error al cargar la configuración del footer:", error);
      }
    };
    fetchConfig();
  }, []);

  const getSmartLink = (type, value, manualLink) => {
    if (manualLink && manualLink.trim() !== "") return manualLink;
    const cleanValue = value ? value.replace(/\s+/g, '') : '';

    switch (type) {
      case 'whatsapp':
        return `https://wa.me/${cleanValue}`;
      case 'mail':
        return `mailto:${value ? value.toLowerCase() : ''}`;
      case 'phone':
        return `tel:${cleanValue}`;
      default:
        return "#";
    }
  };

  const renderIcon = (type) => {
    switch (type) {
      case 'whatsapp': return "💬";
      case 'mail': return "✉️";
      case 'phone': return "📞";
      default: return "📍";
    }
  };

  return (
    <footer className="bg-white border-t border-gray-100 pt-24 pb-12 px-8 selection:bg-[#a6192e] selection:text-white">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12 mb-20">
        <div className="md:col-span-1 space-y-8">
          <div className="relative w-full max-w-[220px] select-none pointer-events-none touch-none">

            <div
              className="h-16 w-full"
              style={{
                backgroundImage: 'url("/grupo_diana_02.png")',
                backgroundSize: 'contain',
                backgroundPosition: 'left center',
                backgroundRepeat: 'no-repeat',
              }}
              aria-label="Grupo Diana"
            />
            <div className="absolute inset-0 z-50 bg-transparent pointer-events-auto" />
          </div>

          <div className="relative border-l border-gray-100 pl-6 group">
            <div className="absolute top-0 left-[-2px] h-0 w-[3px] bg-[#a6192e] transition-all duration-700 group-hover:h-full shadow-[0_0_15px_rgba(166,25,46,0.3)]" />

            <p className="text-slate-500 text-sm leading-relaxed italic font-medium">
              Nuestra historia comenzó en el año <span className="text-slate-900 font-black tracking-wider">2002</span> como un sueño familiar.
              <br /><br />
              Nacimos con el firme propósito de convertirnos en el <span className="text-[#a6192e] font-bold">aliado estratégico</span> de la industria nacional.
            </p>
          </div>
        </div>

        <div>
          <h4 className="text-slate-900 font-black mb-8 text-[10px] uppercase tracking-[0.3em] italic">Explorar</h4>
          <ul className="space-y-4 text-slate-400 text-xs font-bold uppercase tracking-widest">
            <li><Link to="/" className="hover:text-[#a6192e] transition-colors">Inicio</Link></li>
            <li><Link to="/productos" className="hover:text-[#a6192e] transition-colors">Catálogo</Link></li>
            <li><Link to="/nosotros" className="hover:text-[#a6192e] transition-colors">Nosotros</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-slate-900 font-black mb-8 text-[10px] uppercase tracking-[0.3em] italic">Contacto</h4>
          <ul className="space-y-6">
            {config?.contacts && config.contacts.length > 0 ? (
              config.contacts.map((contact) => (
                <li key={contact.id} className="flex flex-col group">
                  <span className="text-[8px] text-[#a6192e] font-black uppercase mb-1 tracking-widest flex items-center gap-2 italic">
                    {renderIcon(contact.icon)} {contact.title}
                  </span>
                  <a
                    href={getSmartLink(contact.icon, contact.value, contact.link)}
                    target={contact.icon === 'mail' || contact.icon === 'phone' ? '_self' : '_blank'}
                    rel="noopener noreferrer"
                    className="text-slate-700 text-xs font-bold italic leading-tight hover:text-[#a6192e] transition-colors inline-block"
                  >
                    {contact.value}
                  </a>
                </li>
              ))
            ) : (
              <p className="text-slate-400 text-[10px] italic">Cargando información...</p>
            )}
          </ul>
        </div>

        <div>
          <h4 className="text-slate-900 font-black mb-8 text-[10px] uppercase tracking-[0.3em] italic">Síguenos</h4>
          <div className="flex gap-4">
            <a
              href="https://www.facebook.com/plasticosdiana"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 rounded-2xl bg-gray-50 border border-gray-100 flex items-center justify-center text-slate-400 hover:bg-[#a6192e] hover:text-white hover:border-[#a6192e] hover:shadow-2xl hover:shadow-red-200 transition-all duration-500 group"
            >
              <svg className="w-5 h-5 transition-transform group-hover:scale-110" fill="currentColor" viewBox="0 0 24 24">
                <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/grupo.diana"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 rounded-2xl bg-gray-50 border border-gray-100 flex items-center justify-center text-slate-400 hover:bg-[#a6192e] hover:text-white hover:border-[#a6192e] hover:shadow-2xl hover:shadow-red-200 transition-all duration-500 group"
            >
              <svg className="w-5 h-5 transition-transform group-hover:scale-110" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto border-t border-gray-100 pt-10 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-[#a6192e text-[9px] tracking-[0.3em] uppercase font-black italic text-center md:text-left leading-none">
          © {new Date().getFullYear()} Grupo Diana • CDMX, México • Todos los derechos reservados
        </p>
      </div>
    </footer>
  );
};

export default Footer;